import type React from "react";
import { forwardRef } from "react";

type InputFieldProps = React.InputHTMLAttributes<HTMLInputElement> & { label: string };
export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(function InputField(props, ref) {
  return (
    <div className={[props.className ?? "", "flex flex-col gap-2"].join(" ")}>
      <label htmlFor={props.id} className="block text-sm font-medium">
        {props.label}
      </label>
      <input {...props} ref={ref} className="rounded-full border px-4 py-3 outline-none" />
    </div>
  );
});

type SelectFieldProps = React.SelectHTMLAttributes<HTMLSelectElement> & { label: string };
export const SelectField = forwardRef<HTMLSelectElement, SelectFieldProps>(function SelectField(props, ref) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={props.id} className="block text-sm font-medium">
        {props.label}
      </label>
      <select {...props} ref={ref} className="appearance-none rounded-full border px-4 py-3 outline-none">
        {props.children}
      </select>
    </div>
  );
});

type TextAreaFieldProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & { label: string };
export const TextAreaField = forwardRef<HTMLTextAreaElement, TextAreaFieldProps>(function TextAreaField(props, ref) {
  return (
    <div className={[props.className ?? "", "flex flex-col gap-2"].join(" ")}>
      <label htmlFor={props.id} className="block text-sm font-medium">
        {props.label}
      </label>
      <textarea {...props} ref={ref} className="w-full rounded-lg border px-4 py-3 outline-none" rows={2} />
    </div>
  );
});
